<template>
  <header class="app-header-desktop">
    <slot></slot>
  </header>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.app-header-desktop {
  position: sticky;
  top: 0;
  width: 100%;
  background: #ffffff;
  border-bottom: 1px solid #F3F4F6;
  z-index: 11;
}
</style>
